import React, { useState } from 'react';
import pluralize from 'pluralize';
import {
  Healthscore,
  Popover,
  Card,
  Box,
  Text,
  Stack,
  Shelf,
  Button,
  Icon,
} from 'chaser-components';
import LoadingMessage from '../../../../../../components/LoadingMessage/index';

import style from './Healthscore.module.scss';

const HealthscoreIdentifier = ({
  healthscore,
  healthscoreData,
  loading,
  name,
  shortCode,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pdf_url, average_dvd, time_savings, updated_at } = {
    ...healthscoreData,
  };

  const formatTimeSaving = timeSaving => {
    if (!timeSaving) return '0';
    let dayStr = '',
      hourStr = '',
      minuteStr = '';
    const { days, hours, minutes } = { ...timeSaving };
    if (days) dayStr = pluralize('day', days, true);
    if (hours) hourStr = pluralize('hours', hours, true);
    if (minutes) minuteStr = pluralize('minute', minutes, true);
    return [dayStr, hourStr, minuteStr, 'p/ week'].join(' ');
  };

  const formatDvd = dvd =>
    pluralize('day', Math.max(0, Math.round(dvd || 0)), true);

  const formatGeneratedDate = generatedDate =>
    generatedDate
      ? new Date(generatedDate).toLocaleString('en-gb', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
      : '-';

  return (
    <div className={style.healthscore}>
      {loading && <LoadingMessage size={20} />}
      {!loading && (
        <Popover
          shown={menuOpen}
          onToggle={open => setMenuOpen(open)}
          target={
            <Healthscore
              data-testid={`healthscore-${name}`}
              isActive={menuOpen}
              isProcessing={healthscore === 'isProcessing'}
              score={healthscore}
            />
          }>
          <Card className={style.dropdownContent}>
            <Box as="div" gap="xsmall">
              <Stack dividers gap="xsmall">
                <Stack gap="xsmall">
                  <Shelf>
                    <Healthscore
                      isProcessing={healthscore === 'isProcessing'}
                      score={healthscore}
                      size="large"
                    />
                    <Stack gap="small">
                      <Stack gap="xsmall">
                        <Text color="Mid Neutral 2">
                          Days to pay vs due date (DvD)
                        </Text>
                        <Text weight="bold">{formatDvd(average_dvd)}</Text>
                      </Stack>
                      <Stack gap="xsmall">
                        <Text color="Mid Neutral 2">Estimated time saving</Text>
                        <Text weight="bold">
                          {formatTimeSaving(time_savings)}
                        </Text>
                      </Stack>
                    </Stack>
                    <div className={style.icon}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://help.chaserhq.com/understand-health-scores-in-partner-hub">
                        <Icon name="help" color="Mid Neutral 2" />
                      </a>
                    </div>
                  </Shelf>
                  <div />
                </Stack>
                {healthscore === 'NA' && (
                  <Text>
                    There was an issue retrieving the healthscore. Please note
                    that the organisation needs to have at least 20 paid
                    invoices.
                  </Text>
                )}
                {healthscore === 'isProcessing' && (
                  <Text>
                    The calculation is still in progress. Depending on the
                    amount of invoices, it can take a few minutes to finish.
                  </Text>
                )}
                {healthscore !== 'isProcessing' && healthscore !== 'NA' && (
                  <Shelf justifyContent="space-between">
                    <Stack gap="xsmall">
                      <Text color="Mid Neutral 2">Score generated on</Text>
                      <Text>{formatGeneratedDate(updated_at)}</Text>
                    </Stack>
                    <Button
                      as="a"
                      narrow
                      disabled={!pdf_url}
                      href={pdf_url}
                      target="_blank"
                      appearance="secondary">
                      Download as PDF
                    </Button>
                  </Shelf>
                )}
              </Stack>
            </Box>
          </Card>
        </Popover>
      )}
    </div>
  );
};

export default HealthscoreIdentifier;
